import { styled } from '@acko-tech/building-blocks.ui.common';

export const TabWrapper = styled.div`
    display: flex;
`;

export const Heading = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    position: relative;
    font-size: 16px;
    line-height: 22px;
    color: ${(props) => props.color};

    &::after {
        content: '';
        position: absolute;
        height: 4px;
        width: 100%;
        border-radius: 5px;
        left: 0px;
        bottom: -12px;
        color: #040222;
        background: ${(props) => props.borderColor};
    }
`;

export const HR = styled.div`
    background: #d6d9e0;
    margin-top: 10px;
    border: 1px solid #d6d9e0;
`;

export const OptionDiv = styled.div`
    ${(props) =>
        !props.singleTab &&
        `
    display: flex;
    flex: 1;
    justify-content: center;`}
`;
